import { OutsideClickHandler } from '@collable/ui'
import styled from '@emotion/styled'
import { createPortal } from 'react-dom'

interface ModalProps {
  children: React.ReactNode
  onClose: () => void
}

const Modal = ({ children, onClose }: ModalProps) => {
  return createPortal(
    <Dim>
      <OutsideClickHandler onOutsideClick={onClose}>
        <Container>{children}</Container>
      </OutsideClickHandler>
    </Dim>,
    document.getElementById('modal-root') as HTMLElement,
  )
}

export default Modal

const Dim = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  top: 0;
`

const Container = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`
